<template>
  <div class="mymsg big">
    <!-- 添加分组 -->
    <el-dialog title="添加分组"
               :visible.sync="dialogadd"
               width="400px"
               style="text-align: left"
               :close-on-click-modal="false">
      <div class="dialog">
        <div style="font-weight: 600">
          <span style="color: red">*</span>
          分组名称
        </div>
        <el-input v-model="add_data.group_name"
                  placeholder="请输入10位以内汉字或字符"
                  maxlength="10"
                  style="margin: 6px 0 16px"></el-input>

        <div style="font-weight: 600">
          <span style="color: red">*</span>
          分组类别
        </div>
        <el-radio-group v-model="add_data.group_type"
                        style="margin: 6px 0 16px">
          <el-radio :label="1">医生分组</el-radio>
          <el-radio :label="2">名医工作室</el-radio>
        </el-radio-group>
        <div style="font-weight: 600">分组说明</div>
        <el-input v-model="add_data.group_desc"
                  placeholder="请输入20位以内汉字或字符"
                  maxlength="20"
                  style="margin: 6px 0 20px"></el-input>
        <div style="text-align: right">
          <el-button @click="dialogadd = false"
                     size="medium">取 消</el-button>
          <el-button type="primary"
                     @click="addGroup"
                     size="medium">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="page_title">医生分组</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox ">
              <div class="flex">
                <span>分组名称</span>
                <el-input v-model="group_name"
                          style="width: 220px; margin: 0 20px 0 10px"
                          @input="search"
                          clearable></el-input>

                <div class="align-center">
                  <span>分组类别</span>
                  <el-radio-group v-model="group_type"
                                  style="margin-top:6px;margin-left:10px">
                    <el-radio :label="-1">全部</el-radio>
                    <el-radio :label="1">医生分组</el-radio>
                    <el-radio :label="2">名医工作室</el-radio>
                  </el-radio-group>
                </div>
                <el-button type="info"
                           style="background-color: #eceff2; color: #747981;margin-left:10px"
                           @click="search"
                           size="medium">查询</el-button>
              </div>
              <el-button type="primary"
                         @click="dialogadd = true;add_data.group_name = '';add_data.group_desc = '';"
                         :disabled="module_id_array[0] ? !module_id_array.includes('582') : false"
                         icon="el-icon-plus">添加分组</el-button>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%; min-width: 1000px"
                        :header-cell-style="{ background: '#F5F5F5' }">
                <el-table-column label="分组名称"
                                 prop="group_name"></el-table-column>

                <el-table-column label="分组说明"
                                 prop="group_desc"></el-table-column>
                <el-table-column label="医生人数"
                                 prop="doctor_count"></el-table-column>

                <el-table-column label="分组类别">
                  <template slot-scope="scope">
                    {{ scope.row.group_type == 1?'医生分组':'名医工作室' }}
                  </template>
                </el-table-column>

                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.visible"> 已启用 </span>
                    <span v-else> 已停用 </span>
                    <el-switch v-model="scope.row.visible"
                               active-color="#669961"
                               style="margin-left: 4px"
                               @change="
                        (value) => {
                          return changeStatus(value, scope.row.group_id);
                        }
                      "
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('584')
                          : false
                      ">
                    </el-switch>
                  </template>
                </el-table-column>

                <el-table-column label="是否公开显示"
                                 prop="">
                  <template slot-scope="scope">
                    <span>{{ scope.row.is_open ===1 ? '是' : '否' }}</span>
                    <!-- <el-switch v-model="scope.row.is_open"
                               :active-value="1"
                               :inactive-value="0"
                               @change="(value) => {return changeOpen(value,scope.row);}"
                               :disabled="module_id_array[0]? !module_id_array.includes('791'): false">
                    </el-switch> -->
                  </template>

                </el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text"
                               @click="toDetail(scope.row.group_id)"
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('599')
                          : false
                      ">查看详情</el-button>
                    <el-button type="text"
                               @click="
                        delGroup(scope.row.group_id, scope.row.doctor_count)
                      "
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('585')
                          : false
                      ">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
                             :current-page="currentPage"
                             :page-sizes="[10, 20, 50, 100]"
                             :page-size="10"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="totalNum"
                             style="margin:20px 0"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import clinic from '../../../api/clinic';
import _ from 'lodash';
import department from '../../../api/department';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      group_type: -1,
      tableData: [],
      add_data: {
        group_name: '',
        group_type: 1,
        group_desc: ''
      },
      group_name: '',
      dialogadd: false
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        group_name: this.group_name,
        group_type: this.group_type
      };
      this.axios
        .post('platform/sdepartment/getFamousDoctorGroupList', data)
        .then((res) => {
          if (res.code == 0) {
            // if (!res.data.list.length) {
            //   this.currentPage = 1;
            //   this.getList();
            //   return;
            // }
            this.tableData = res.data.list.map((item) => {
              item.visible = item.is_visible ? true : false;
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //添加特色药房
    addGroup() {
      if (!this.add_data.group_name) {
        this.$message.error('请输入分组名称');
        return false;
      }
      let data = this.add_data;
      this.axios
        .post('platform/sdepartment/saveFamousDoctorGroupInfo', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('添加成功');
            this.dialogadd = false;
            this.getList();
          }
        });
    },
    toDetail(group_id) {
      this.$router.push({
        path: 'doctordetail',
        query: {
          group_id
        }
      });
    },
    // // 是否公开
    // changeOpen(value, row) {
    //   console.log(value);
    //   let params = {
    //     group_id: row.group_id,
    //     is_open: value
    //   };
    //   department.changeIsOpenStatus(params).then((res) => {
    //     let { code } = res;
    //     if (code === 0) {
    //       this.$message.success('操作成功');
    //       this.getList();
    //     }
    //   });
    // },
    //更改状态
    changeStatus(value, group_id) {
      let data = {
        group_id: group_id,
        is_visible: 0
      };
      let msg = '停用';
      if (value) {
        data.is_visible = 1;
        msg = '启用';
      }

      this.$confirm(`是否${msg}该分组？`, '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/sdepartment/changeFamousDoctorGroupStatus', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    //删除
    delGroup(group_id, doctor_count) {
      if (doctor_count) {
        this.$confirm('已绑定医生, 不允许删除', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定'
        })
          .then(() => {})
          .catch(() => {});
        return false;
      }
      this.$confirm('是否删除该分组？', '提示消息', {
        cancelButtonText: '取消',
        confirmButtonText: '确定'
      })
        .then(() => {
          this.axios
            .post('platform/sdepartment/deleteFamousDoctorGroupInfo', {
              group_id
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.dialog {
  padding: 20px 30px 20px;
}
</style>

